<template>
    <div>
        <hero></hero>
        <i-bunches></i-bunches>
        <l-footer></l-footer>
    </div>
</template>

<script>
    export default {
        name: "Bunches"
    }
</script>

<style scoped>

</style>
